import script from "./DiceRoller.vue?vue&type=script&setup=true&lang=js"
export * from "./DiceRoller.vue?vue&type=script&setup=true&lang=js"

import "./DiceRoller.vue?vue&type=style&index=0&id=0c6948f1&lang=css"

const __exports__ = script;

export default __exports__